import { DotPlot } from './DotPlot';


export const FaDetailPlot = ( {data, width, height, xScale, yScale, r, color, title}) => {
    return (
        <DotPlot
            data={data}
            width={width}
            height={height}
            xScale={xScale}
            yScale={yScale}
            r={r}
            color={() => color}
            title={title}
            setSelectedLipid={() => null}
        />
    )
}